import {createFileRoute, redirect} from '@tanstack/react-router';
import PatientHome from '@/patient/views/user/UserHome';
import {CurrentPractitioner} from '@/practitioner/interfaces/Practitioner';
import {PATIENT_LIST, WORK_LIST} from '@/practitioner/routing/paths';
import {AppRouterContext} from '@/shared/routing';

function HomeWrapper() {
  return <PatientHome />;
}

export const Route = createFileRoute('/(shared)/home')({
  component: HomeWrapper,
  beforeLoad: function ({context}: {context: AppRouterContext}) {
    if (context.isPatient) {
      return;
    }
    const currentPractitioner = context.currentUser as CurrentPractitioner;
    if (currentPractitioner.isAdmissions) {
      throw redirect({to: PATIENT_LIST, replace: true});
    }
    throw redirect({to: WORK_LIST, replace: true});
  }
});
